import React, { useState} from "react";
import { Card } from "antd";
import { Coins, Star, TrendingUp, Users } from "lucide-react";



const OverviewSummaryCard = (props) => {
  const {
  } = props;

  const overviewStatus =
  [  
    {
      id: 1,
      title: "Company Balance",
      icon: Coins,
      count: 4050,
      info: "Available credits",
      color: "emerald-white",
    },
    {
      id: 2,
      title: "This Month",
      icon: TrendingUp,
      count: 550,
      info: "Credits awarded",
      color: "purple-white",
    },
    {
      id: 3,
      title: "Active Team",
      icon: Users,
      count: 3,
      info: "Members awarded",
      color: "blue-white",
    },
    {
      id: 3,
      title: "Avg. per Person",
      icon: Star,
      count: 3,
      info: "Credits awarded",
      color: "amber-white",
    },

  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {overviewStatus.map((item) => {
        const Icon = item.icon;
        return(
          <Card
          key={item.id}
          className={`rounded-xl card-border-s ${item.color}`}
        >
          <div className="flex items-center justify-between"> 
            <div>
              <p className="text-[12px] text-muted-foreground mb-1">{item.title}</p>
              <p className="text-[24px] font-semibold card-text">{item.count.toLocaleString()}</p>
              <p className="text-xs">{item.info}</p>
            </div>
            <div className="icon-theme p-3 rounded-xl">
              <Icon className="w-8 h-8" />
            </div>
          </div>
        </Card>   
        );
      })}
    </div>
  );
};

export default OverviewSummaryCard;
